import THDStorageUtils, { LOCAL_STORAGE } from '@thd-olt-global/thd-storage-utils';

const shouldClearStorage = (calculateObj) => {
  const { areas } = calculateObj;
  let shouldClearStorageBool = true;

  const depthArrHasNonDefaultValues = areas.some((el) => !['3', ''].includes(el.depth));
  const areaArrHasValues = areas.some((el) => el.squareFootage.value !== '');
  const calcValuesExist = ((areas.some((el) => el.name !== '' || el.length !== '' || el.width !== '')
    || depthArrHasNonDefaultValues
    || areaArrHasValues));

  if (calcValuesExist) shouldClearStorageBool = false;

  return shouldClearStorageBool;
};

const formatStorageKey = (productInfo) => {
  if (!productInfo) {
    return null;
  }
  const { productDepartment = '', classNumber = '' } = productInfo;
  const DCS = `${productDepartment}-${classNumber}`;
  const storageKey = 'PIP-' + DCS;
  return storageKey;
};

const getStorageObject = (storageKey) => {
  try {
    const storageValue = THDStorageUtils.get(LOCAL_STORAGE, { key: storageKey });
    const storageObject = storageValue !== 'undefined' ? JSON.parse(storageValue) : null;

    return storageObject;
  } catch {
    return null;
  }
};

export const saveStorageObject = (storageKey, calculate) => {
  const {
    calcByArea, calcByLengthWidth, step, value, areas, addAdditionalCoverage
  } = calculate;
  const storageObj = getStorageObject(storageKey);

  if (!storageObj && shouldClearStorage(calculate)) return;
  if (storageObj && shouldClearStorage(calculate)) {
    THDStorageUtils.remove(LOCAL_STORAGE, { key: storageKey });
  } else {
    THDStorageUtils.set(LOCAL_STORAGE, {
      key: storageKey,
      value: JSON.stringify({
        calcByArea,
        calcByLengthWidth,
        step,
        value,
        areas,
        addAdditionalCoverage
      })
    });
  }
};

export const getCalculatorLocalStorage = ({ classInfo }) => {
  const storageKey = formatStorageKey(classInfo);
  let storageObj = null;
  if (storageKey) {
    storageObj = getStorageObject(storageKey);
  }
  return {
    storageKey,
    storageObj
  };
};